module.exports = __webpack_public_path__ + "static/media/odisha.69e74b2e.png";